import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTemplatesBlockersGet = {
    path: "/templates/blocker",
    method: RouteHttpVerb.GET
};
export { locationRestTemplatesBlockersGet };
